import { CountryCode } from "Components/Features/CheckPrice/Products/AkaProducts/AkaStudent/ProductIntro/akaStudentProductIntroInterfaces";
import CheckoutTexts from "Store/texts/checkoutTextInterface";

export enum TextLanguage {
  ENGLISH = "en",
  NORWEGIAN_BOKMAAL = "nb",
}

export interface TextDomains {
  checkout: CheckoutTexts;
  products: BaseProducts;
  checkPrice: any;
}

export interface TextState {
  domain: TextDomains | any;
  isLoading: boolean;
  fetched: boolean;
  error: string | null;
  language: TextLanguage;
}

export default Text;

interface BaseProducts {
  header: string;
  descriptionTitle: string;
}

export type TranslatedText = Record<TextLanguage, string>;
export type TranslatedTextList = Record<TextLanguage, string[]>;

export enum FmsTextVariable {
  PHONE_NUMBER = "{phoneNumber}",
}

export interface CoverageCardText {
  infoHeader: { nb: string; en: string };
  additionalInfo: { nb: string; en: string };
  coverages: any;
}

export type AkaStudentCountries = {
  readonly optionsList: CountryGroup[];
  readonly countriesNotAllowed: string[];
};

export type CountryGroup = {
  readonly code: CountryCode;
  readonly name?: string;
  readonly countries: string[];
};

export type Country = {
  readonly code: CountryCode;
  readonly name: string;
};
